export default __webpack_public_path__ + "static/work-card-4a9d79314282814e58cc0fda88c7ba8d.png";